<template>
    <div class="input-container" :class="label ? 'input-container-with-label' : '' ">
        <form-label-title v-if="label" :label="label" :is-required="isRequired" />

        <el-select v-model="value" 
                   filterable
                   class="select-input"
                   :placeholder="placeholder"
                   :size="size"
                   clearable
                   @change="handleChange($event)"
        >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.name"
                :value="item.id"
                :disabled="item.disabled"
            />
        </el-select>
    </div>
</template>

<script>
import FormLabelTitle from "./FormLabelTitle";

export default {
    components: {
        "form-label-title": FormLabelTitle,
    },
    props: {
        inputValue: {
            type: String | Number
        },
        label: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        size: {
            type: String,
            default: "small"
        },
        isRequired: {
            type: Boolean
        }
    },
    data() {
        return {
            options: [
                { id: true, name: "Yes" },
                { id: false, name: "No" }
            ],
        };
    },
    computed: {
        value: {
            set(val) {
                console.log("set", val);
                this.$emit("update:inputValue", val);
            },
            get() {
                if (this.inputValue == null || this.inputValue == "") {
                    return this.inputValue;
                }
                else if (typeof this.inputValue == "string") {
                    return this.inputValue == "true";
                }
                else {
                    return Boolean(this.inputValue);
                }
            }
        }
    },
    methods: {
        handleChange(value) {
            this.$emit("handleChange", value);
        }
    },
};
</script>

<style lang="css" scoped>
.select-input{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Form/FormBoolean.vue